/**
 * Nusa Wear Modesty — Product page enhancements
 * - Description "Lire la suite / Lire moins"
 */
(function () {
  'use strict';

  // Description truncate
  const desc = document.querySelector('.product__description');
  if (!desc) return;

  // Wrap le contenu dans un div tronquable
  const inner = document.createElement('div');
  inner.className = 'nusa-desc-truncate';
  while (desc.firstChild) inner.appendChild(desc.firstChild);
  desc.appendChild(inner);

  // Dégradé
  const fade = document.createElement('div');
  fade.className = 'nusa-desc-fade';
  desc.appendChild(fade);

  // Bouton
  const btn = document.createElement('button');
  btn.className = 'nusa-desc-toggle';
  btn.innerHTML = 'Lire la suite <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 5l4 4 4-4"/></svg>';
  btn.setAttribute('aria-expanded', 'false');
  desc.appendChild(btn);

  // Vérifier si le contenu est suffisamment long pour tronquer
  if (inner.scrollHeight <= inner.clientHeight + 10) {
    fade.style.display = 'none';
    btn.style.display = 'none';
    return;
  }

  btn.addEventListener('click', () => {
    const isOpen = inner.classList.toggle('nusa-desc-open');
    fade.classList.toggle('nusa-desc-open', isOpen);
    btn.setAttribute('aria-expanded', String(isOpen));
    btn.innerHTML = isOpen
      ? 'Lire moins <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 9l4-4 4 4"/></svg>'
      : 'Lire la suite <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 5l4 4 4-4"/></svg>';
  });
})();
